import { IS_PROD_ENVIRONMENT } from '@/config/app.config';

export class IntercomClient {
  static showChat() {
    if (!IS_PROD_ENVIRONMENT || !Intercom) return;

    Intercom('show');
  }
}
